import LinkModelI from '@/components/interfaces/ILinkModel';

export default class MessageBoxObject {
  title: string;

  text: string;

  buttonLink: LinkModelI;

  constructor(title: string, text: string, buttonLink: LinkModelI) {
    this.title = title;
    this.text = text;
    this.buttonLink = buttonLink as LinkModelI;
  }
}
